// extracted by mini-css-extract-plugin
export default {"pagination":"SearchResult_pagination__n4aUb","searchQueryTxt":"SearchResult_searchQueryTxt__McJ1X","btn":"SearchResult_btn__DxcYj","currentPage":"SearchResult_currentPage__-q3eC"};